const mainBox = {
    border: '2px solid black',
    backgroundColor: '#918b93',
    paddingLeft: '5px',
    paddingRight: '5px',
    paddingBottom: '5px',
    color: 'white'
}
const textAlignCenter = {
    textAlign: 'center'
}
const welcomeStyle = {
    fontSize: '1.5rem', 
    fontWeight: '100'
}
const formStyle = {
    border: '2px solid white',
    paddingLeft: '50px',
    paddingRight: '50px',
    backgroundColor: 'white',
    color: 'black'
}
const loginHead ={
    fontWeight: '100',
    paddingTop: '15px'
}
const inputTextBox = {
    width: "350px",
    borderRadius: "5px",
    height: "25px",
    padding: "15px",
    marginBottom: "10px"
}
const firstRow ={
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '5px'
}
const secondRow ={
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center', 
    marginTop: '15px', 
    marginBottom: '20px'
}
const link ={
    textDecoration: 'none',
    fontSize: '13px'
}
const checkBox={
    width: '15px',
    height: '15px'
}
const loginBtn={
    padding: '10px',
    paddingLeft: '20px',
    paddingRight: '20px'
}
const iconRow = {
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'space-evenly'
}
const igIcon={
    width: '45px', 
    height: '45px'
}
const fbIcon={
    width: '49px', 
    height: '49px'
}
const googleIcon={
    width: '73px', 
    height: '73px'
}
const fs_10={
    fontSize: '10px'
}

export const styles = {
    mainBox : mainBox,
    textAlignCenter : textAlignCenter,
    welcomeStyle: welcomeStyle,
    formStyle: formStyle, 
    loginHead: loginHead,
    inputTextBox: inputTextBox,
    firstRow: firstRow,
    secondRow: secondRow,
    link: link,
    checkBox: checkBox,
    loginBtn: loginBtn,
    iconRow: iconRow,
    igIcon: igIcon,
    fbIcon: fbIcon,
    googleIcon: googleIcon,
    fs_10: fs_10
}